// extracted by mini-css-extract-plugin
module.exports = {"rowTotal":"user-stats_rowTotal__2JlON","spinner":"user-stats_spinner__2Z6Ck"};